var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"info"},on:{"click":_vm.edit}},[_vm._v(" 編集 ")])}
var staticRenderFns = []

export { render, staticRenderFns }